import { Component, Input } from '@angular/core';
import { IPropertyGroup } from '../../models/entity.interface';
import { UiPropertyListComponent } from '../ui-property-list/ui-property-list.component';

@Component({
  selector: 'ui-property-group',
  templateUrl: './ui-property-group.component.html',
  styleUrls: ['./ui-property-group.component.css'],
  imports: [UiPropertyListComponent]
})
export class UiPropertyGroupComponent {

  @Input('group') public hostGroup!: IPropertyGroup;

  constructor() { }

}
